{
  "box.1.label": "Absender (Name, Anschrift, Land)",
  "box.2.label": "Empfänger (Name, Anschrift, Land)",
  "box.3.label": "Auslieferungsort des Gutes (Ort, Land)",
  "box.4.label": "Ort und Tag der Übernahme des Gutes (Ort, Land, Datum)",
  "box.5.label": "Beigefügte Dokumente",
  "box.6.label": "Kennzeichen und Nummern",
  "box.7.label": "Anzahl der Packstücke",
  "box.8.label": "Art der Verpackung",
  "box.9.label": "Bezeichnung des Gutes",
  "box.10.label": "Statistiknummer",
  "box.11.label": "Bruttogewicht in kg",
  "box.12.label": "Umfang in m3",
  "box.13.label": "Anweisungen des Absenders",
  "box.14.label": "Frachtzahlungsanweisungen",
  "box.15.label": "Nachnahme",
  "box.16.label": "Frachtführer (Name, Anschrift, Land)",
  "box.17.label": "Nachfolgende Frachtführer (Name, Anschrift, Land)",
  "box.18.label": "Vorbehalte und Bemerkungen der Frachtführer",
  "box.19.label": "Besondere Vereinbarungen",
  "box.20.label": "Zu zahlen vom",
  "box.21.label": "Ausgefertigt in, am",
  "box.22.label": "Unterschrift und Stempel des Absenders",
  "box.23.label": "Unterschrift und Stempel des Frachtführers",
  "box.24.label": "Gut empfangen (Ort, Datum, Unterschrift und Stempel des Empfängers)",
  "box.18.continued": "Nicht alles passt in dieses Feld. Die vollständige Liste mit {total, plural, one {# Vorbehalt} other {# Vorbehalten}} steht im Anhang auf Seite {page}.",
  "annex.box18": "Anhang Feld 18 — Vorbehalte und Bemerkungen des Frachtführers",
  "document.title": "Internationaler Frachtbrief",
  "document.convention_note": "Diese Beförderung unterliegt trotz einer gegenteiligen Abmachung den Bestimmungen des Übereinkommens CMR.",
  "document.ecmr_number": "Frachtbriefnummer",
  "document.reference": "Referenz",
  "document.version": "Version {version}",
  "document.continuation": "Fortsetzung",
  "document.page_of": "Seite {page} von {pages}",
  "document.inspection_code": "Prüfcode",
  "document.efti_certification": "eFTI-Plattform: nicht zertifiziert (Test)",
  "label.vat_number": "USt-IdNr.",
  "label.vehicle": "Fahrzeug",
  "label.trailer": "Anhänger",
  "label.driver": "Fahrer",
  "label.window": "Zeitfenster",
  "label.dangerous_goods": "Gefahrgut (ADR)",
  "label.adr_class": "Klasse",
  "label.adr_packing_group": "Verpackungsgruppe",
  "label.adr_tunnel_code": "Tunnelcode",
  "label.adr_limited_quantity": "Begrenzte Menge",
  "label.adr_environmentally_hazardous": "Umweltgefährdend",
  "label.carriage_charges": "Frachtkosten",
  "label.total": "Gesamt",
  "value.payer.consignor": "Absender",
  "value.payer.consignee": "Empfänger",
  "value.payer.principal": "Auftraggeber",
  "value.carriage_paid": "Frei",
  "value.carriage_forward": "Unfrei",
  "value.package.pallet": "Palette",
  "value.package.box": "Kiste",
  "value.package.carton": "Karton",
  "value.package.crate": "Verschlag",
  "value.package.bag": "Sack",
  "value.package.drum": "Fass",
  "value.package.roll": "Rolle",
  "value.package.bundle": "Bündel",
  "value.package.container": "Container",
  "value.package.loose": "Lose",
  "value.package.other": "Sonstiges",
  "signature.signed_electronically": "Elektronisch unterzeichnet über Cargofollow",
  "signature.pending": "Noch nicht unterzeichnet",
  "signature.method.drawn": "Auf dem Bildschirm unterschrieben",
  "signature.method.click_otp": "Mit Einmalcode bestätigt",
  "signature.method.api": "Über die API unterzeichnet",
  "signature.method.photo_of_paper": "Foto einer Unterschrift auf Papier",
  "signature.trust.platform_auth": "Plattform-Authentifizierung",
  "signature.trust.ades": "Fortgeschrittene Signatur (AdES)",
  "signature.trust.qes": "Qualifizierte Signatur (QES)",
  "signature.seal": "Siegel einer juristischen Person",
  "label.signed_at": "Unterzeichnet am",
  "label.method": "Methode",
  "label.trust_level": "Vertrauensniveau",
  "label.document_hash": "Dokument-Hash",
  "label.location": "Standort",
  "label.accuracy": "Genauigkeit",
  "pod.title": "Proof of delivery",
  "pod.intro": "Ablieferungsnachweis zum obenstehenden Frachtbrief.",
  "pod.delivered_at": "Abgeliefert am",
  "pod.consignee_signature": "Unterschrift des Empfängers",
  "pod.colli": "Packstückkontrolle",
  "pod.colli_expected": "Packstücke laut Frachtbrief",
  "pod.remarks": "Vorbehalte und Bemerkungen",
  "pod.no_remarks": "Ohne Vorbehalt abgeliefert.",
  "pod.remarks_on_form": "Nicht alles passt hier. Die vollständige Liste steht in Feld 18 des Frachtbriefs auf Seite 1.",
  "pod.photos": "Fotos",
  "pod.photos_omitted": "{count} Foto(s) nicht abgebildet, um das Dokument klein zu halten.",
  "pod.remark.phase.pickup": "Bei der Übernahme",
  "pod.remark.phase.delivery": "Bei der Ablieferung",
  "pod.remark.type.damage": "Schaden",
  "pod.remark.type.shortage": "Fehlmenge",
  "pod.remark.type.delay": "Verspätung",
  "pod.remark.type.other": "Sonstiges"
}
